import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.realisticrealtors.com";

// These pages set their own canonical and og:url (from the blog/property slug
// or the API), so this component leaves them alone.
const PAGES_WITH_OWN_CANONICAL = [/^\/blogs$/, /^\/blog\//, /^\/property\//, /^\/privacypolicy$/];

// Routes that show the same page as another URL point to that URL instead.
const CANONICAL_ALIASES = {
  "/home": "/",
  "/banner_image": "/",
  "/services": "/",
  "/Insights": "/insights",
};

// Gives every other page a canonical tag and og:url for its own URL (always
// www, no query string, no trailing slash). Without it these pages have no
// canonical and keep the og:url from public/index.html, which is the homepage.
const CanonicalTag = () => {
  const { pathname } = useLocation();

  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const hasOwnCanonical = PAGES_WITH_OWN_CANONICAL.some((pattern) => pattern.test(path));

  useEffect(() => {
    // Remove the homepage og:url from public/index.html; react-helmet-async
    // does not replace tags that were already in the HTML.
    if (!hasOwnCanonical) {
      document.getElementById("default-og-url")?.remove();
    }
  }, [hasOwnCanonical]);

  if (hasOwnCanonical) {
    return null;
  }

  const canonicalPath = CANONICAL_ALIASES[path] || path;
  const canonicalUrl = `${SITE_URL}${canonicalPath === "/" ? "/" : canonicalPath}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;
